import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
const chips = ['+350 pág.', '70+ protocolos aplicables', 'Recetas cetogénicas', 'Checklists de crisis listos', 'Registro de convulsiones', 'Planificación médica 2026', 'Bebés y niños pequeños', 'Edad escolar', 'Deporte y recreo', 'Hogar y seguridad', 'Nutrición y dieta', 'Medicación', 'Crisis nocturnas', 'Colegio y docentes', 'Familia y entorno'];
const contents = ['Comprensión completa de la epilepsia y tipos de crisis', 'Protocolo de acción antes, durante y después de una convulsión', 'Dieta cetogénica adaptada para niños argentinos', 'Manejo de medicación antiepiléptica y efectos secundarios', 'Plan de acción escolar y manual para docentes', 'Guía completa para toda la familia', 'Derechos y cobertura de obra social/prepaga en Argentina', 'Diario de convulsiones y seguimiento 2026', 'Protocolo de seguridad nocturna y SUDEP', 'Red de apoyo y recursos en Argentina'];
export const SystemFeatures = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-white" data-id="element-242">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <div className="text-center mb-6 sm:mb-10" data-id="element-244">
          <div className="inline-block bg-brand-gold/20 text-brand-green font-bold px-4 py-1.5 rounded-full text-sm mb-3 sm:mb-4" data-id="element-245">
            SISTEMA N°1 EN ARGENTINA
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-246">
            Para Madres de Niños con Epilepsia
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-brand-orange font-semibold" data-id="element-247">
            Sistema completo · 4 Tomos + 3 Bonos · De 2 a 16 años · Todo
            resuelto.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-8 sm:mb-10 md:mb-12" data-id="element-248">
          {chips.map((chip, i) => <span key={i} className="flex items-center gap-1.5 bg-brand-green/5 text-brand-green px-3 py-1.5 rounded-full font-medium border border-brand-green/10 text-xs sm:text-sm" data-id="element-249">
              <CheckCircle2 size={14} className="text-brand-green" data-id="element-250" />
              {chip}
            </span>)}
        </motion.div>

        <div className="bg-cream-dark rounded-2xl p-5 sm:p-6 md:p-8 border border-brand-orange/20 shadow-sm text-center mb-8 sm:mb-10 md:mb-12" data-id="element-251">
          <p className="text-base sm:text-lg md:text-xl font-heading font-semibold text-gray-800" data-id="element-252">
            Funciona desde esta semana en tu hogar, ya sea que tu hijo acabe de
            ser diagnosticado o lleve años con epilepsia.
          </p>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-253">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 flex items-center gap-2 justify-center" data-id="element-254">
            <BookOpen className="text-brand-orange" size={24} data-id="element-255" /> Contenidos
            incluidos:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3" data-id="element-256">
            {contents.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="flex items-start gap-3" data-id="element-257">
                <div className="mt-1 bg-brand-orange/20 p-1 rounded-full" data-id="element-258">
                  <div className="w-2 h-2 bg-brand-orange rounded-full" data-id="element-259"></div>
                </div>
                <span className="text-gray-700 font-medium text-sm sm:text-base" data-id="element-260">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};